import React from 'react';
import { badge, badgeBorderless, badgeSecondary, badgeSecondary as badgeDefault, borderless, button, buttonContainer, buttonGroup, buttonGroupFullWidth, combinators, dropdownIcon, dropdownIconSecondary, dropdownIconSecondary as dropdownIconDefault, hiddenText, iconContainer, iconContainerRight, loader, loaderBorderless, loaderSecondary, loaderSecondary as loaderDefault, loaderDot, loaderDot1, loaderDot2, loaderDotSecondary, loaderDotSecondary as loaderDotDefault, loaderDotBorderless, loadingAnimation, notification, notificationBlack, notificationBlue, notificationRed, notificationBorderless, notificationBorderlessBlack, notificationBorderlessBlue, notificationBorderlessRed, secondary, secondary as defaultButton, splitButtonLeft, splitButtonRight, splitButtonLeftSecondary, splitButtonLeftSecondary as splitButtonLeftDefault, splitButtonRightSecondary, splitButtonRightSecondary as splitButtonRightDefault, splitButtonWrapper, stackableGroup, } from '../styles/legacy';
import { badge as badgeCitron, badgeBorderless as badgeBorderlessCitron, badgeSecondary as badgeSecondaryCitron, badgeDefault as badgeDefaultCitron, borderless as borderlessCitron, button as buttonCitron, buttonContainer as buttonContainerCitron, buttonGroup as buttonGroupCitron, buttonGroupFullWidth as buttonGroupFullWidthCitron, combinators as combinatorsCitron, iconContainerSmall, iconContainerMedium, iconContainerLarge, loader as loaderCitron, loaderBorderless as loaderBorderlessCitron, loaderSecondary as loaderSecondaryCitron, loaderDefault as loaderDefaultCitron, loaderDot as loaderDotCitron, loaderDotBorderless as loaderDotBorderlessCitron, loaderDotSecondary as loaderDotSecondaryCitron, loaderDotDefault as loaderDotDefaultCitron, notification as notificationCitron, notificationBlack as notificationBlackCitron, notificationBlue as notificationBlueCitron, notificationRed as notificationRedCitron, notificationBorderless as notificationBorderlessCitron, notificationBorderlessBlack as notificationBorderlessBlackCitron, notificationBorderlessBlue as notificationBorderlessBlueCitron, notificationBorderlessRed as notificationBorderlessRedCitron, secondary as secondaryCitron, defaultButton as defaultButtonCitron, splitButtonLeft as splitButtonLeftCitron, splitButtonRight as splitButtonRightCitron, splitButtonLeftSecondary as splitButtonLeftSecondaryCitron, splitButtonRightSecondary as splitButtonRightSecondaryCitron, stackableGroup as stackableGroupCitron, splitButtonLeftDefault as splitButtonLeftDefaultCitron, splitButtonRightDefault as splitButtonRightDefaultCitron, } from '../styles/citron';
import { css } from 'emotion';
import { citrusStyled } from '@citrus/runtime';
export var ButtonGroup = citrusStyled.div('buttonGroup', { legacy: buttonGroup, citrus2022: buttonGroupCitron }, { combinators: { legacy: combinators, citrus2022: combinatorsCitron } });
export var ButtonGroupFullWidth = citrusStyled.div('buttonGroupFullWidth', { legacy: buttonGroupFullWidth, citrus2022: buttonGroupFullWidthCitron }, {
    combinators: { legacy: combinators, citrus2022: combinatorsCitron },
});
export var StackableGroup = citrusStyled.div('stackableGroup', { legacy: stackableGroup, citrus2022: stackableGroupCitron }, { combinators: { legacy: combinators, citrus2022: combinatorsCitron } });
export var ButtonContainer = citrusStyled.div('buttonContainer', {
    legacy: buttonContainer,
    citrus2022: buttonContainerCitron,
});
export var ButtonIconSmall = citrusStyled.div('iconContainer', {
    legacy: iconContainer,
    citrus2022: iconContainerSmall,
});
export var ButtonIconMedium = citrusStyled.div('iconContainer', {
    legacy: iconContainer,
    citrus2022: iconContainerMedium,
});
export var ButtonIconLarge = citrusStyled.div('iconContainer', {
    legacy: iconContainer,
    citrus2022: iconContainerLarge,
});
export var ButtonIconRight = citrusStyled.div('iconContainerRight', iconContainerRight);
export var ButtonText = citrusStyled.div('N/A', {});
export var Badge = citrusStyled.div('badge', { legacy: badge, citrus2022: badgeCitron });
export var BadgeSecondary = citrusStyled.div('badgeSecondary', {
    legacy: badgeSecondary,
    citrus2022: badgeSecondaryCitron,
});
export var BadgeDefault = citrusStyled.div('badgeDefault', {
    legacy: badgeDefault,
    citrus2022: badgeDefaultCitron,
});
export var BadgeBorderless = citrusStyled.div('badgeBorderless', {
    legacy: badgeBorderless,
    citrus2022: badgeBorderlessCitron,
});
export var HiddenText = citrusStyled.span('hiddenText', hiddenText);
var Loader = citrusStyled.div('loader', { legacy: loader, citrus2022: loaderCitron });
var LoaderSecondary = citrusStyled.div('loaderSecondary', {
    legacy: loaderSecondary,
    citrus2022: loaderSecondaryCitron,
});
var LoaderDefault = citrusStyled.div('loaderDefault', {
    legacy: loaderDefault,
    citrus2022: loaderDefaultCitron,
});
var LoaderBorderless = citrusStyled.div('loaderBorderless', {
    legacy: loaderBorderless,
    citrus2022: loaderBorderlessCitron,
});
var LoadingAnimation = citrusStyled.div('loadingAnimation', loadingAnimation);
var LoaderDot = citrusStyled.div('loaderDot', { legacy: loaderDot, citrus2022: loaderDotCitron });
var LoaderDotSecondary = citrusStyled.div('loaderDotSecondary', {
    legacy: loaderDotSecondary,
    citrus2022: loaderDotSecondaryCitron,
});
var LoaderDotDefault = citrusStyled.div('loaderDotDefault', {
    legacy: loaderDotDefault,
    citrus2022: loaderDotDefaultCitron,
});
var LoaderDotBorderless = citrusStyled.div('loaderDotBorderless', {
    legacy: loaderDotBorderless,
    citrus2022: loaderDotBorderlessCitron,
});
export var DropdownIcon = citrusStyled.span('dropdownIcon', dropdownIcon);
export var DropdownIconSecondary = citrusStyled.span('dropdownIconSecondary', dropdownIconSecondary);
export var DropdownIconDefault = citrusStyled.span('dropdownIconDefault', dropdownIconDefault);
export var ButtonLoader = function () { return (React.createElement(Loader, null,
    React.createElement(LoadingAnimation, null,
        React.createElement(LoaderDot, { className: css(loaderDot1) }),
        React.createElement(LoaderDot, { className: css(loaderDot2) }),
        React.createElement(LoaderDot, null)))); };
export var SecondaryButtonLoader = function () { return (React.createElement(LoaderSecondary, null,
    React.createElement(LoadingAnimation, null,
        React.createElement(LoaderDotSecondary, { className: css(loaderDot1) }),
        React.createElement(LoaderDotSecondary, { className: css(loaderDot2) }),
        React.createElement(LoaderDotSecondary, null)))); };
export var DefaultButtonLoader = function () { return (React.createElement(LoaderDefault, null,
    React.createElement(LoadingAnimation, null,
        React.createElement(LoaderDotDefault, { className: css(loaderDot1) }),
        React.createElement(LoaderDotDefault, { className: css(loaderDot2) }),
        React.createElement(LoaderDotDefault, null)))); };
export var BorderlessButtonLoader = function () { return (React.createElement(LoaderBorderless, null,
    React.createElement(LoadingAnimation, null,
        React.createElement(LoaderDotBorderless, { className: css(loaderDot1) }),
        React.createElement(LoaderDotBorderless, { className: css(loaderDot2) }),
        React.createElement(LoaderDotBorderless, null)))); };
export var BorderlessAs = function (as) {
    return citrusStyled.as(as)('borderless', { legacy: borderless, citrus2022: borderlessCitron }, { combinators: { legacy: combinators, citrus2022: combinatorsCitron } });
};
export var BorderlessIconAs = function (as) {
    return citrusStyled.as(as)('borderless', { legacy: borderless, citrus2022: borderlessCitron });
};
export var ButtonAs = function (as) {
    return citrusStyled.as(as)('button', { legacy: button, citrus2022: buttonCitron }, { combinators: { legacy: combinators, citrus2022: combinatorsCitron } });
};
export var SecondaryAs = function (as) {
    return citrusStyled.as(as)('secondary', { legacy: secondary, citrus2022: secondaryCitron }, { combinators: { legacy: combinators, citrus2022: combinatorsCitron } });
};
export var DefaultAs = function (as) {
    return citrusStyled.as(as)('default', { legacy: defaultButton, citrus2022: defaultButtonCitron }, { combinators: { legacy: combinators, citrus2022: combinatorsCitron } });
};
export var NotificationAs = function (as) {
    return citrusStyled.as(as)('notification', { legacy: notification, citrus2022: notificationCitron }, { combinators: { legacy: combinators, citrus2022: combinatorsCitron } });
};
export var NotificationBlackAs = function (as) {
    return citrusStyled.as(as)('notificationBlack', { legacy: notificationBlack, citrus2022: notificationBlackCitron }, { combinators: { legacy: combinators, citrus2022: combinatorsCitron } });
};
export var NotificationBlueAs = function (as) {
    return citrusStyled.as(as)('notificationBlue', { legacy: notificationBlue, citrus2022: notificationBlueCitron }, { combinators: { legacy: combinators, citrus2022: combinatorsCitron } });
};
export var NotificationRedAs = function (as) {
    return citrusStyled.as(as)('notificationRed', { legacy: notificationRed, citrus2022: notificationRedCitron }, { combinators: { legacy: combinators, citrus2022: combinatorsCitron } });
};
export var BorderlessNotificationAs = function (as) {
    return citrusStyled.as(as)('notificationBorderless', { legacy: notificationBorderless, citrus2022: notificationBorderlessCitron }, { combinators: { legacy: combinators, citrus2022: combinatorsCitron } });
};
export var BorderlessNotificationBlackAs = function (as) {
    return citrusStyled.as(as)('notificationBorderlessBlack', { legacy: notificationBorderlessBlack, citrus2022: notificationBorderlessBlackCitron }, {
        combinators: { legacy: combinators, citrus2022: combinatorsCitron },
    });
};
export var BorderlessNotificationBlueAs = function (as) {
    return citrusStyled.as(as)('notificationBorderlessBlue', { legacy: notificationBorderlessBlue, citrus2022: notificationBorderlessBlueCitron }, {
        combinators: { legacy: combinators, citrus2022: combinatorsCitron },
    });
};
export var BorderlessNotificationRedAs = function (as) {
    return citrusStyled.as(as)('notificationBorderlessRed', { legacy: notificationBorderlessRed, citrus2022: notificationBorderlessRedCitron }, {
        combinators: { legacy: combinators, citrus2022: combinatorsCitron },
    });
};
export var Borderless = citrusStyled.button('borderless', { legacy: borderless, citrus2022: borderlessCitron }, { combinators: { legacy: combinators, citrus2022: combinatorsCitron } });
export var BorderlessIcon = citrusStyled.button('borderless', {
    legacy: borderless,
    citrus2022: borderlessCitron,
});
export var Button = citrusStyled.button('button', { legacy: button, citrus2022: buttonCitron }, { combinators: { legacy: combinators, citrus2022: combinatorsCitron } });
export var Secondary = citrusStyled.button('secondary', { legacy: secondary, citrus2022: secondaryCitron }, { combinators: { legacy: combinators, citrus2022: combinatorsCitron } });
export var DefaultButton = citrusStyled.button('default', { legacy: defaultButton, citrus2022: defaultButtonCitron }, { combinators: { legacy: combinators, citrus2022: combinatorsCitron } });
export var Notification = citrusStyled.button('notification', { legacy: notification, citrus2022: notificationCitron }, { combinators: { legacy: combinators, citrus2022: combinatorsCitron } });
export var NotificationBlack = citrusStyled.button('notificationBlack', { legacy: notificationBlack, citrus2022: notificationBlackCitron }, { combinators: { legacy: combinators, citrus2022: combinatorsCitron } });
export var NotificationBlue = citrusStyled.button('notificationBlue', { legacy: notificationBlue, citrus2022: notificationBlueCitron }, { combinators: { legacy: combinators, citrus2022: combinatorsCitron } });
export var NotificationRed = citrusStyled.button('notificationRed', { legacy: notificationRed, citrus2022: notificationRedCitron }, { combinators: { legacy: combinators, citrus2022: combinatorsCitron } });
export var BorderlessNotification = citrusStyled.button('notificationBorderless', { legacy: notificationBorderless, citrus2022: notificationBorderlessCitron }, { combinators: { legacy: combinators, citrus2022: combinatorsCitron } });
export var BorderlessNotificationBlack = citrusStyled.button('notificationBorderlessBlack', { legacy: notificationBorderlessBlack, citrus2022: notificationBorderlessBlackCitron }, { combinators: { legacy: combinators, citrus2022: combinatorsCitron } });
export var BorderlessNotificationBlue = citrusStyled.button('notificationBorderlessBlue', { legacy: notificationBorderlessBlue, citrus2022: notificationBorderlessBlueCitron }, { combinators: { legacy: combinators, citrus2022: combinatorsCitron } });
export var BorderlessNotificationRed = citrusStyled.button('notificationBorderlessRed', { legacy: notificationBorderlessRed, citrus2022: notificationBorderlessRedCitron }, { combinators: { legacy: combinators, citrus2022: combinatorsCitron } });
export var SplitButtonWrapper = citrusStyled.div('splitButtonWrapper', splitButtonWrapper, {
    combinators: { legacy: combinators, citrus2022: combinatorsCitron },
});
export var SplitButtonLeft = citrusStyled.button('splitButtonLeft', {
    legacy: splitButtonLeft,
    citrus2022: splitButtonLeftCitron,
});
export var SplitButtonRight = citrusStyled.button('splitButtonRight', {
    legacy: splitButtonRight,
    citrus2022: splitButtonRightCitron,
});
export var SplitButtonLeftSecondary = citrusStyled.button('splitButtonLeftSecondary', {
    legacy: splitButtonLeftSecondary,
    citrus2022: splitButtonLeftSecondaryCitron,
});
export var SplitButtonRightSecondary = citrusStyled.button('splitButtonRightSecondary', {
    legacy: splitButtonRightSecondary,
    citrus2022: splitButtonRightSecondaryCitron,
});
export var SplitButtonLeftDefault = citrusStyled.button('splitButtonLeftDefault', {
    legacy: splitButtonLeftDefault,
    citrus2022: splitButtonLeftDefaultCitron,
});
export var SplitButtonRightDefault = citrusStyled.button('splitButtonRightDefault', {
    legacy: splitButtonRightDefault,
    citrus2022: splitButtonRightDefaultCitron,
});
export var Styled = {
    ButtonGroup: ButtonGroup,
    ButtonGroupFullWidth: ButtonGroupFullWidth,
    ButtonContainer: ButtonContainer,
    ButtonIconSmall: ButtonIconSmall,
    ButtonIconMedium: ButtonIconMedium,
    ButtonIcon: ButtonIconMedium,
    ButtonIconLarge: ButtonIconLarge,
    ButtonIconRight: ButtonIconRight,
    ButtonText: ButtonText,
    Badge: Badge,
    BadgeSecondary: BadgeSecondary,
    BadgeDefault: BadgeDefault,
    BadgeBorderless: BadgeBorderless,
    Loader: Loader,
    LoaderSecondary: LoaderSecondary,
    LoaderBorderless: LoaderBorderless,
    LoadingAnimation: LoadingAnimation,
    LoaderDot: LoaderDot,
    LoaderDotBorderless: LoaderDotBorderless,
    DropdownIcon: DropdownIcon,
    DropdownIconSecondary: DropdownIconSecondary,
    DropdownIconDefault: DropdownIconDefault,
    Borderless: Borderless,
    BorderlessIcon: BorderlessIcon,
    Button: Button,
    Secondary: Secondary,
    DefaultButton: DefaultButton,
    Notification: Notification,
    NotificationBlack: NotificationBlack,
    NotificationBlue: NotificationBlue,
    NotificationRed: NotificationRed,
    BorderlessNotification: BorderlessNotification,
    BorderlessNotificationBlack: BorderlessNotificationBlack,
    BorderlessNotificationBlue: BorderlessNotificationBlue,
    BorderlessNotificationRed: BorderlessNotificationRed,
    SplitButtonWrapper: SplitButtonWrapper,
    SplitButtonLeft: SplitButtonLeft,
    SplitButtonRight: SplitButtonRight,
    SplitButtonLeftSecondary: SplitButtonLeftSecondary,
    SplitButtonRightSecondary: SplitButtonRightSecondary,
    StackableGroup: StackableGroup,
    SplitButtonLeftDefault: SplitButtonLeftDefault,
    SplitButtonRightDefault: SplitButtonRightDefault,
    BorderlessAs: BorderlessAs,
    BorderlessIconAs: BorderlessIconAs,
    ButtonAs: ButtonAs,
    SecondaryAs: SecondaryAs,
    DefaultAs: DefaultAs,
    NotificationAs: NotificationAs,
    NotificationBlackAs: NotificationBlackAs,
    NotificationBlueAs: NotificationBlueAs,
    NotificationRedAs: NotificationRedAs,
    BorderlessNotificationAs: BorderlessNotificationAs,
    BorderlessNotificationBlackAs: BorderlessNotificationBlackAs,
    BorderlessNotificationBlueAs: BorderlessNotificationBlueAs,
    BorderlessNotificationRedAs: BorderlessNotificationRedAs,
};
